import { defineMessages } from '../translate';

/** Client-side request failures (`shared/api/client.ts`, `files.ts`, …). */
export default defineMessages('lib-api', {
  sessionExpired: 'Session expired',
  sessionExpiredBody: 'Please sign in again to continue.',
  requestTimeout: 'The request took too long. Please try again.',
  renewFailed: 'Could not renew your session. Please retry.',
  sessionEnded: 'Your session ended. Sign in again before continuing.',
  refreshUnavailable: "Couldn't renew your session right now. Check your connection — we'll retry shortly.",
  serverError: 'Something went wrong on our end. Please try again in a moment.',
  genericError: 'Something went wrong. Please try again.',
  sessionChanged: 'Your session changed. Sign in again before continuing.',
  networkError: "Couldn't reach the server. Check your connection and try again.",
  rateLimitedWait: 'Too many requests. Please wait {seconds}s and try again.',
  rateLimited: 'Too many requests. Please wait a moment and try again.',
  byokKeyWorks: '{label} key works ✓',
  byokKeyUnchecked: '{label} key saved, but {label} could not be reached to check it. It will be used as is.',
  exportFailed: 'Export failed. Please try again.',
  // Uploads — {name} is the quoted file name.
  uploadNetwork: 'Couldn\'t upload {name} — check your connection and try again.',
  uploadEmpty: "{name} is empty — there's nothing to upload.",
  uploadChanged: '{name} changed while uploading — please try again.',
  uploadLinkExpired: 'The upload link for {name} expired — please try again.',
  uploadTooLarge: '{name} is too large to upload.',
  uploadServerError: 'Upload of {name} failed on our side — please try again in a moment.',
  uploadFailedStatus: 'Upload of {name} failed (HTTP {status}) — please try again.',
} as const);
